import React from 'react'
import { AnalyticsMetric } from '../../../types/Metrics'
import { useMetricServerConnection } from './hooks'
import { MetricList } from './MetricList'

type MetricCardsBarExpandedProps = {
  metrics: AnalyticsMetric[]
  resortId: string
}

const MetricCardsBarExpanded = ({ metrics, resortId }: MetricCardsBarExpandedProps) => {
  useMetricServerConnection(resortId)
  return <MetricList variant="row" metrics={metrics} />
}

export default MetricCardsBarExpanded
